import { render } from "./ApprovedRequests.vue?vue&type=template&id=db928de8"
import script from "./ApprovedRequests.vue?vue&type=script&lang=js"
export * from "./ApprovedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__